import React from 'react';
import Marquee from 'react-fast-marquee';
import './ModernPartners.scss';

// Import partner logos
import ciscoLogo from '../../images/brands/cisco-logo.svg';
import dellLogo from '../../images/brands/Dell_Logo.svg.png';
import hpLogo from '../../images/brands/Hewlett-Packard-Logo.wine.png';
import samsungLogo from '../../images/brands/samsung-logo.svg';
import lenovoLogo from '../../images/partnes/WIth Removed Background/lenovo-logo-brand-phone-symbol-name-red-design-china-mobile-illustration-free-vector-removebg-preview.png';
import starkeyLogo from '../../images/partnes/WIth Removed Background/starkey-removebg-preview.png';
import viewsonicLogo from '../../images/brands/logo.webp';
import targusLogo from '../../images/partnes/WIth Removed Background/Targus-Logo-Med-Purple-removebg-preview.png';

const ModernPartners = () => {
    const partners = [
        { name: 'Cisco', logo: ciscoLogo },
        { name: 'Dell', logo: dellLogo },
        { name: 'HP', logo: hpLogo },
        { name: 'Samsung', logo: samsungLogo },
        { name: 'Lenovo', logo: lenovoLogo },
        { name: 'Starkey', logo: starkeyLogo },
        { name: 'ViewSonic', logo: viewsonicLogo },
        { name: 'Targus', logo: targusLogo },
    ];

    return (
        <section className="jk-partners">
            <div className="jk-partners__container">
                <div className="jk-partners__header">
                    <span className="jk-partners__label">Trusted Partners</span>
                    <p className="jk-partners__text">
                        Partnering with industry leaders to deliver exceptional technology solutions
                    </p>
                </div>

                <div className="jk-partners__marquee">
                    <Marquee
                        speed={40}
                        gradient={true}
                        gradientColor="#ffffff"
                        gradientWidth={100}
                        pauseOnHover={true}
                    >
                        {partners.concat(partners).map((partner, index) => (
                            <div key={index} className="jk-partners__item">
                                <img
                                    src={partner.logo}
                                    alt={partner.name}
                                    className="jk-partners__logo"
                                />
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </section>
    );
};

export default ModernPartners;
